export const normalizeId = (value: unknown): string => {
    if (typeof value === 'string') return value;
    if (typeof value === 'number') return String(value);
    if (value && typeof value === 'object') {
        const maybeOid = (value as { $oid?: unknown }).$oid;
        if (typeof maybeOid === 'string') return maybeOid;
    }
    return '';
};
